<template>
  <div>
    <Breadcrumb :style="{margin: '24px 0'}">
        <BreadcrumbItem>首页</BreadcrumbItem>
        <BreadcrumbItem>网站设置</BreadcrumbItem>
        <BreadcrumbItem>个人信息设置</BreadcrumbItem>
    </Breadcrumb>
    <Content :style="{padding: '24px', minHeight: '280px', background: '#fff'}">
      <div class="head_style">
        <h2>个人信息设置</h2>
      </div>
      <div>
        <p ><b>姓名</b></p>
        <Input  placeholder="请输入姓名" class="input-width" v-model="websiteinfo.username" />
      </div><br>

      <div>
        <p ><b>职业</b></p>
        <Input  placeholder="请输入职业" class="input-width" v-model="websiteinfo.white" />
      </div><br>
      <div>
        <p ><b>邮箱</b></p>
        <Input  placeholder="请输入职业" class="input-width" v-model="websiteinfo.email" />
      </div><br>

      <div>
        <p ><b>定位</b></p>
        <Input  placeholder="请输入职业" class="input-width" v-model="websiteinfo.position" />
      </div><br>
      <div>
        <p ><b>二维码图片</b></p>
        <div>
          <img :src="websiteinfo.img" id="web_favicon" class="img_style">
        </div>
        <Upload action="/admin/Website/uploadImg" name="image" :on-success="handleSuccess" :show-upload-list="false">
            <Button icon="ios-cloud-upload-outline" id="ghost" >文件上传</Button>
        </Upload>
      </div><br>

      <div class="button_style">
        <Button type="success" @click="webSitePutData()">提交</Button>
      </div><br>
    </Content>
  </div>
</template>
<style scoped>
* {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}
p {
  line-height: 30px;
}
.head_style {
  height: 50px;
}
.img_style{
  height:200px;
}
.input-width{
  width: 700px;
}


</style>
<script>
import personal from '@/assets/js/views/bak/personal';

export default {
  ...personal,
};
</script>

